export const TerminalStatusIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 22 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 8.4286V15C21 16.1046 20.1046 17 19 17H6C4.89543 17 4 16.1046 4 15V13.5M21 8.4286V7C21 5.89543 20.1046 5 19 5H18M21 8.4286H18"
      stroke="#444444"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 5V11.5C18 12.6046 17.1046 13.5 16 13.5H3C1.89543 13.5 1 12.6046 1 11.5V3.5C1 2.39543 1.89543 1.5 3 1.5H16C17.1046 1.5 18 2.39543 18 3.5V5ZM18 5H4.5"
      stroke="#444444"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
